import { render, staticRenderFns } from "./AssetMoreInfo.vue?vue&type=template&id=23fc0a36&scoped=true&"
import script from "./AssetMoreInfo.vue?vue&type=script&lang=js&"
export * from "./AssetMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./AssetMoreInfo.vue?vue&type=style&index=0&id=23fc0a36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc0a36",
  null
  
)

export default component.exports